<template>
  <div v-if="hasRecentQueries" class="on-focus__recent-queries-container q-text-dark">
    <div class="on-focus__recent-queries-content q-text-dark">
      <QueriesContainer
          :can-remove="true"
          :queries="userRecentQueriesStore.recentQueries"
          :queries-header="SmartSearchTranslations.userRecentQueries.header"/>

    </div>
  </div>
</template>

<script lang="ts" setup>
import QueriesContainer from '../Queries/QueriesContainer.vue'
import {useUserRecentQueriesStore} from "@/store/AutocompletePopup/UserRecentQueriesStore";
import { onMounted, inject} from "vue";
import {storeToRefs} from "pinia";
import {SmartSearchTranslationsInterface} from "@/core/types";

const userRecentQueriesStore = useUserRecentQueriesStore()
const {hasRecentQueries} = storeToRefs(userRecentQueriesStore)
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

onMounted(() => {
  userRecentQueriesStore.getQueries()
})

</script>

<style scoped>


a {
  cursor: pointer;
}
</style>